import { render } from "./CatsPage.vue?vue&type=template&id=2147bd40&scoped=true"
import script from "./CatsPage.vue?vue&type=script&lang=js"
export * from "./CatsPage.vue?vue&type=script&lang=js"

import "./CatsPage.vue?vue&type=style&index=0&id=2147bd40&scoped=true&lang=css"

import exportComponent from "C:\\Users\\pc07\\Documents\\GitHub\\lezione-online-test\\gatthotel\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2147bd40"]])

export default __exports__